import IncidentsOverview from './IncidentsOverview/IncidentsOverview';
import IncidentsTable from './IncidentsTable/IncidentsTable';
import React from 'react';

const IncidentsOverviewPage = () => {
    return (
        <div className="w-full h-full flex flex-col flex-1 px-6">
            <div className="w-full my-4 !h-[248px] flex-none">
                <IncidentsOverview />
            </div>
            <div className="h-50 flex flex-grow flex-shrink">
                <IncidentsTable />
            </div>
        </div>
    );
};

export default IncidentsOverviewPage;
